/* eslint-disable */
import { format } from 'date-fns';
import api from '@/services/api';

export default {
  async fetchProcessosPaginados({ dispatch, commit }, filtrosFetch = {}) {
    // commit('UPDATE_PROCESSES', []);
    dispatch('toggleLoading', true, { root: true });
    let filtros = {...filtrosFetch };
    let params = new URLSearchParams();

    if (filtros.periodo && filtros.periodo.length > 1) {
      const [dataInicial, dataFinal] = filtros.periodo.map((date) => format(new Date(date), 'yyyy-MM-dd'));
      params.append('dataInicial', dataInicial);
      params.append('dataFinal', dataFinal);
      delete filtros.periodo;
    }

    const statusCodes = {
      'PRÉ-EMBARQUE': 1,
      'EM TRÂNSITO': 2,
      'DESEMBARAÇO': 3,
      'CARREGAMENTO': 4,
      'FECHAMENTO': 5,
    };

    const keys = Object.keys(filtros);
    delete filtros.periodo;
    if (filtros.campoData && filtros.campoData.length === 0) {
      delete filtros.campoData;
    }
    if (filtros.codigoStatusEmbarque && filtros.codigoStatusEmbarque.length === 0) {
      delete filtros.codigoStatusEmbarque;
    } else if(filtros.codigoStatusEmbarque) {
      let codes = [];
      for (const code of filtros.codigoStatusEmbarque) {
        codes.push(statusCodes[code]);
      }
      const codesStr = codes.join(',');
      params.append('codigoStatusEmbarque', codesStr);
      delete filtros.codigoStatusEmbarque;
    }
    /* eslint-disable */
    for (const key of keys) {
      if (filtros[key]) {
        params.append(key, filtros[key]);
      }
    }

    try {
      const { data } = await api.get('/processo/paginate', { params });

      commit('UPDATE_PROCESSES', data.registros.data);
      commit('paginacao/SET_PAGINADOR', data.registros, { root: true });

      return data;
    } catch (err) {
      dispatch('setGlobalError', 'Não foi possível recuperar os processos!', {
        root: true,
      });
    } finally {
      dispatch('toggleLoading', false, { root: true });
    }
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async getTotalProcesses({ dispatch, commit }) {
    dispatch('toggleLoading', true, { root: true });
    try {
      const response = await api.get('/processo/total');
      commit('UPDATE_TOTAL_PROCESSES', response.data.total);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar os totais por etapa de cada processo!',
        { root: true },
      );
    }
    dispatch('toggleLoading', false, { root: true });
  },
  async getTotalProcessesByStatus({ dispatch, commit }) {
    dispatch('toggleLoading', true, { root: true });
    try {
      const response = await api.get('/processo/total/etapa');
      const results = response.data.registros;
      const series = [];
      for (let i = 0; i < results.length; i++) {
        for (let j = 1; j <= 5; j++) {
          if (j === parseInt(results[i].status)) {
            series.push(results[i].total);
          }
        }
      }
      commit('UPDATE_TOTAL_PROCESSES_SERIES', series);
      commit('UPDATE_TOTAL_PROCESSES_BY_STATUS', response.data.registros);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar os totais por etapa de cada processo!',
        { root: true },
      );
    }
    dispatch('toggleLoading', false, { root: true });
  },
  async getProcesses({ dispatch, commit }, filtros = {}) {
    const {
      campoData, periodo, termo, encerrado, avoidLoading
    } = filtros;

    if (!avoidLoading) {
      dispatch('toggleLoading', true, { root: true });
    }

    const params = new URLSearchParams();

    if (campoData) {
      params.append('campo', campoData);
    }

    if (periodo && periodo[0]) {
      const dataInicial = format(new Date(periodo[0]), 'yyyy-MM-dd');
      params.append('dataInicial', dataInicial);
    }

    if (periodo && periodo[1]) {
      const dataFinal = format(new Date(periodo[1]), 'yyyy-MM-dd');
      params.append('dataFinal', dataFinal);
    }

    if (termo) {
      params.append('termo', termo);
    }

    if (encerrado) {
      params.append('encerrado', encerrado);
    }

    try {
      const response = await api.get('/processo', { params });
      commit('UPDATE_PROCESSES', response.data.registros);
    } catch (err) {
      dispatch('setGlobalError', 'Não foi possível recuperar os processos!', {
        root: true,
      });
    } finally {
      dispatch('toggleLoading', false, { root: true });
    }
  },
  async fetchAllArquivosProcessos({ dispatch, commit }, payload) {
    commit('UPDATE_PROCESSOS_ARQUIVOS', []);
    dispatch('toggleLoading', true, { root: true });
    try {
      let filtrosPayload = {...payload};
      const { periodo } = filtrosPayload;
      delete filtrosPayload.periodo;
      delete filtrosPayload.campoData;
      const params = new URLSearchParams();

      if (periodo.length > 0 && periodo[0]) {
        const dataInicial = format(new Date(periodo[0]), 'yyyy-MM-dd');
        params.append('dataInicial', dataInicial);
      }

      if (periodo.length > 0 && periodo[1]) {
        const dataFinal = format(new Date(periodo[1]), 'yyyy-MM-dd');
        params.append('dataFinal', dataFinal);
      }

      const keys = Object.keys(filtrosPayload);
      /* eslint-disable */
      for (const key of keys) {
        if (filtrosPayload[key]) {
          params.append(key, filtrosPayload[key]);
        }
      }
      const response = await api.get('/processoArquivos/arquivos', { params });
      commit('UPDATE_PROCESSOS_ARQUIVOS', response.data.data);
      commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar os arquivos!',
        { root: true },
      );
    } finally {
      dispatch('toggleLoading', false, { root: true });
    }
  },
  async getLis({ dispatch, commit }, payload) {
    dispatch('toggleLoading', true, { root: true });
    try {
      const response = await api.get(`/processo/lis/${payload.codigo}/filial/${payload.filial}`);
      commit('LIS_PROCESS', response.data);
    } catch (err) {
      dispatch(
        'setGlobalError',
        `Não foi possível recuperar as LI's do processo ${payload.codigoProcesso}!`,
        { root: true },
      );
    }
    dispatch('toggleLoading', false, { root: true });
  },
  async selectProcess({ dispatch, commit }, payload) {
    commit('SET_OBJECT', payload);
    if (!payload.avoidLoading) {
      dispatch('toggleLoading', true, { root: true });
    }
    
    try {
      const response = await api.get(`/processo/codigo/${payload.codigoProcesso}/filial/${payload.codigoFilial}`);
      commit('SELECT_PROCESS', response.data);
    } catch (err) {
      dispatch(
        'setGlobalError',
        `Não foi possível recuperar o processo ${payload.codigoProcesso}!`,
        { root: true },
      );
    }
    dispatch('toggleLoading', false, { root: true });
  },
  updateColunasDisponiveis({ commit }, payload) {
    commit('UPDATE_COLUNAS_DISPONIVEIS', payload);
  },
  limparState({ commit }) {
    commit('UPDATE_PROCESSES', []);
  },
  filtrarMapaPorStatus({ commit }, status) {
    commit('SET_FILTRO_MAPA_STATUS', status);
  },
  processosFiltrar({ commit }, payload) {
    commit('SET_PROCESSOS_FILTRAR', payload);
  },
  async fetchEmTempoAtrasados({ commit }) {
    const { data } = await api.get('processo/total-processos-atrasados-tempo');
    commit('SET_EM_TEMPO_ATRASADOS', data.tempoMedio);
  },
  async getCheckAccount(_, payload) {
    const response = await api.get(
      `/processo/conta_corrente/${payload.PRI_COD}/${payload.FIL_COD}`,
    );
    return response.data.registros;
  },
  async openProcessUpdates(_, payload) {
    if (payload !== undefined) {
      const response = await api.get(
        `/processo/atualizacao/${payload.PRI_COD}/filial/${payload.FIL_COD}`,
      );
      return response.data.registros;
    }
  },
  async getDocs({ commit }, payload) {
    const response = await api.get(
      `/arquivo/processo/${payload.PRI_COD}/filial/${payload.FIL_COD}`,
    );
    commit('SET_DOCUMENTOS_PROCESSO_SELECIONADO', response.data.registros);
    return response.data.registros;
  },
  async getDis(_, payload) {
    const response = await api.get(`/processo/di/${payload.PRI_COD}/filial/${payload.FIL_COD}`);

    if (response.data?.length) {
      return response.data[0];
    }
    return {};
  },
  async fetchProcessoFromCnpjAndCodigo(_, payload) {
    const response = await api.get(`/processo/empresa/${payload.cnpj}/referencia/${payload.referencia}`);
    return response.data;
  }
};
